// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_wI5","cls2":"AutoCompleteResults-cls2_zwL AutoCompleteResults-cls1_wI5"};